import utilRouter from "@/libs/util.router.js";
const config = {
  navMenuConfig: {
    title: "广东轻工职业技术学院人民数字马院",
    menuBackgroundColor: "#fff",
    menuTextColor: "#444",
    menuActiveTextColor: "#d00",
  },
  relationId: "3517",
  menuList: [
    {
      title: "首页",
      type: 1,
      content: "/csmz/portal",
      subMenuList: [],
      isActive: utilRouter.isPathActive,
    },
    {
      title: "新闻动态",
      type: 1,
      content: `/csmz/news/2422?type=1`,
      subMenuList: [],
      isActive: isNewsActive(2422),
    },
    {
      title: "通知公告",
      type: 1,
      content: `/csmz/news/2423?type=2`,
      subMenuList: [],
      isActive: isNewsActive(2423),
    },
    {
      title: "政策文件",
      type: 1,
      content: `/csmz/news/2424?type=2`,
      subMenuList: [],
      isActive: isNewsActive(2424),
    },
    {
      title: "经典原著",
      type: 1,
      content: `/csmz/news/2425?type=2`,
      subMenuList: [],
      isActive: isNewsActive(2425),
    },
    {
      title: "德育工作资源库",
      type: 2,
      content: `#/csmz/resource`,
      isActive: utilRouter.isPathActive,
      subMenuList: [],
    },
    {
      title: "教师发展培训",
      type: 1,
      content: "/csmz/ideologicalCourses",
      isActive: utilRouter.isPathActive,
      subMenuList: [],
    },
    {
      title: "赛事评审",
      type: 2,
      content: `https://kcszyjy-dasai.ulearning.cn`,
      isActive: utilRouter.isPathActive,
      subMenuList: [],
    },
  ],
   menus : [{
    id: 0,
    title: "首页",
    type: 1,
    path: '/csmz/portal'
  }, {
    id: 1,
    title: "新闻动态",
    type: 1,
    menuId: 2422, //1583
    path: '/csmz/news/2422?type=1'
  }, {
    id: 1,
    title: "通知公告",
    type: 1,
    menuId: 2423, //1583
    path: '/csmz/news/2423?type=2'
  }, {
    id: 2,
    title: "政策文件",
    type: 1,
    menuId: 2424, //1584
    path: '/csmz/news/2424?type=2'
  }, {
    id: 2,
    title: "经典原著",
    type: 1,
    menuId: 2425, //1584
    path: '/csmz/news/2425?type=2'
  }, {
    id: 3,
    title: "德育工作资源库",
    type: 2,
    path: '#/csmz/resources'
  }, {
    id: 4,
    title: "教师发展培训",
    type: 1,
    path: '/csmz/ideologicalCourses'
    // path: 'https://ua.ulearning.cn/teacher-development'
  }, {
    id: 5,
    title: "赛事评审",
    type: 2,
    path: 'https://kcszyjy-dasai.ulearning.cn'
  }]
};
function isNewsActive(id) {
  var rules = [
    {
      path: "/csmz/news/:menuId",
      params: {
        menuId: id,
      },
    },
    {
      path: "/csmz/newsContent/:menuId/:id",
      params: {
        menuId: id,
      },
    },
  ];

  return function(route) {
    return utilRouter.isMatch(route, rules);
  };
}
// function isResourcesActive() {
//   var rules = [
//     {
//       path: "/tjxd/resourceContent",
//     },
//     {
//       path: "/tjxd/resources",
//     },
//   ];

//   return function(route) {
//     return utilRouter.isMatch(route, rules);
//   };
// }
// function isCourseActive(id) {
//   var rules = [{
//     path: "/tjxd/courses/:id",
//     params: {
//       id: id
//     }
//   }];
//   return function (route) {
//     return utilRouter.isMatch(route, rules)
//   }
// }
// function isElaborateActive(id) {
//   var rules = [{
//     path: "/tjxd/elaborate/:declareType",
//     params: {
//       declareType: id
//     }
//   }];
//   return function (route) {
//     return utilRouter.isMatch(route, rules)
//   }
// }
// function isSchoolLevelActive(id) {
//   var rules = [{
//     path: "/tjxd/schoolLevel/:declareType",
//     params: {
//       declareType: id
//     }
//   }];
//   return function (route) {
//     return utilRouter.isMatch(route, rules)
//   }
// }

export default config;
export const resourceList = [{
  link: "https://rm.ulearning.cn/#/portal/351/42149",
  icon: "icon1sizhengjiaoyutizhijizhichuangxin1",
  text: "思政教育体制机制创新",
  text2: "思政教育<br>体制机制创新"
},
{
  link: "https://rm.ulearning.cn/#/portal/351/42150",
  icon: "icon2sizhengkegaige1",
  text: "思政理论课改革"
}, {
  link: "https://rm.ulearning.cn/#/portal/351/42151",
  icon: "icon3kechengsizhenggaige",
  text: "课程思政改革"
}, {
  link: "https://rm.ulearning.cn/#/portal/351/42427",
  icon: "icon4wenhuayuren",
  text: "文化育人"
}, {
  link: "https://rm.ulearning.cn/#/portal/351/42152",
  icon: "icon5chuangxinhuodongyurenmoshi",
  text: "创新活动育人模式"
}, {
  link: "https://rm.ulearning.cn/#/portal/351/42430",
  icon: "icon6laodongjiaoyu",
  text: "劳动教育"
}, {
  link: "https://rm.ulearning.cn/#/portal/351/43306",
  icon: "icon7sizhengjiaoyuxiaoguoceping",
  text: "学生思想政治素养评价"
}, {
  link: "https://rm.ulearning.cn/#/portal/351/42431",
  icon: "icon8hongseyurenziyuanzhenghe",
  text: "红色育人资源整合"
}, {
  link: "https://rm.ulearning.cn/#/portal/351/42428",
  icon: "icon9xiaoqiyuren",
  text: "校企协同育人"
}, {
  link: "https://rm.ulearning.cn/#/portal/351/42432",
  icon: "icon10xueshengshequyuguanliyuren",
  text: "学生社区与管理育人",
  text2: "学生社区与管理<br>育人"
}, {
  link: "https://rm.ulearning.cn/#/portal/351/42429",
  icon: "icon11guanliyufuwuyuren1",
  text: "管理服务育人"
},
{
  link: "https://rm.ulearning.cn/#/portal/351/",
  type: 1,
  icon: "icon12chakangengduo",
  text: "查看更多"
}
]

export const collegeList = [{
  'logo': 'gdqg.png',
  'name': '广东轻工职业技术学院',
  'link': 'http://www.gdqy.edu.cn/'
},
{
  'logo': 'szzy.png',
  'name': '深圳职业技术学院',
  'link': 'http://www.szpt.edu.cn/'
},
{
  'logo': 'whzy.png',
  'name': '武汉职业技术学院',
  'link': 'http://www.wtc.edu.cn/'
}, {
  'logo': 'csmz.png',
  'name': '长沙民政职业技术学院',
  'link': 'http://www.csmzxy.edu.cn/'
},
{
  'logo': 'cqzy.png',
  'name': '重庆工业职业技术学院',
  'link': 'http://www.cqipc.edu.cn/'
},
{
  'logo': 'szxxzy.png',
  'name': '深圳信息职业技术学院',
  'link': 'https://www.sziit.edu.cn/'
}, {
  'logo': 'jxhj.png',
  'name': '江西环境工程职业学院',
  'link': 'http://www.jxhjxy.com'
},
{
  'logo': 'hnqc.png',
  'name': '湖南汽车工程职业学院',
  'link': 'http://www.zzptc.com'
}
]